module.exports = __webpack_public_path__ + "media/images/icons/club_bi_benefits-c2cef17175ec9535accd4612c4d33405.svg";